import OrangeArrow from '../../assets/OrangeArrow'
import { H2 } from '@sbab-ui/components'

export default function ReadMore() {
  return (
    <div className="!mb-15 !mt-11 flex flex-col px-1.5 md:mt-9">
      <H2 className="!text-2xl md:mt-0 md:!text-[2rem]">
        Fler sätt att förverkliga energirenoveringen!
      </H2>

      <p className="mt-[15px] text-lg">
        Om Kilowattlånet inte passar dig kan du läsa mer om vårt Energilån utan säkerhet här.
      </p>

      <a
        href="/1/privat/lana/privatlan/energilan_med_rabatt.html"
        className="mt-6 flex w-fit items-center space-x-2 font-medium"
        aria-label="Länk till Energilånet"
      >
        <span>Läs mer om Energilånet</span>{' '}
        <OrangeArrow className="size-6" aria-label="Knapp till Energilånet" />
      </a>
    </div>
  )
}
